<!--<app-notification></app-notification>-->
<!--<app-upload-progress></app-upload-progress>-->

<div class="wrapper">
  <ng-content>
  </ng-content>
</div>
